<template>
  <b-container class="container">
      <b-row align-h="center">
        <b-col sm="3" md="6" lg="6"> 
          <b-img src="../assets/logo.svg" fluid center class="logoimg"/>
        </b-col>
      </b-row> 
    <b-form> <!-- START FORM -->
    <div v-show="showpageone">
      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-1"
            label="First Name:"
            label-for="input-1"
            class="input-title"
          >
            <b-form-input
              id="input-1"
              v-model="form.firstname"
              type="text"
              class="forminput"
              minlength="3" pattern="^[A-Za-z]+$"
              required
              :state="validenglish(form.firstname)"
              @keyup="removenonenglishfirstname()"
              placeholder="First Name (ENGLISH)"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-h="center" v-show="showmiddlename">
        <b-col lg="6">    
          <b-form-group
            id="input-group-1a"
            label="Middle Name:"
            label-for="input-1a"
            class="input-title"
          >
            <b-form-input
              id="input-1a"
              v-model="form.middlename"
              type="text"
              class="forminput"
              minlength="3" pattern="^[A-Za-z]+$"
              :required="showmiddlename"
              :state="validenglish(form.middlename)"
              @keyup="removenonenglishmiddlename()"
              placeholder="Middle Name (ENGLISH)"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-2"
            label="Last Name:"
            label-for="input-2"
            class="input-title"
          >
            <b-form-input
              id="input-2"
              v-model="form.lastname"
              type="text"
              class="forminput"
              minlength="3" pattern="^[A-Za-z]+$"
              required
              :state="validenglish(form.lastname)"
              @keyup="removenonenglishlastname()"
              placeholder="Last Name (ENGLISH)"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-3"
            label="Email Address:"
            label-for="input-3"
            class="input-title"
          >
            <b-form-input
              id="input-3"
              v-model="form.email"
              type="text"
              class="forminput"
              required
              @keyup="emailbackendcheck"
              :state="emailvalidation"
              placeholder="Enter your Email"
            ></b-form-input>
            
            <b-form-invalid-feedback :state="emailvalidation">
              {{emailerror}}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-4"
            label="Phone Number:"
            label-for="input-4"
            class="input-title"
          >
          <vue-phone-number-input v-model="phone" @update="convertphone" size="lg" default-country-code="LY" color="#ff0000"  required clearable/>
          </b-form-group>
         </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-5a"
            label="Create NUQTA Username: (For Wifi)"
            label-for="input-5a"
            class="input-title"
          >
            <b-form-input
              id="input-5a"
              v-model="form.username"
              type="text"
              class="forminput"
              required
              @keyup="usernamebackendcheck"
              :state="usernamevalidation"
              placeholder="Create a new username"
            ></b-form-input>
            
            <b-form-invalid-feedback :state="usernamevalidation">
              {{usernameerror}}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-5b"
            label="Create NUQTA Password: (For Wifi)"
            label-for="input-5b"
            class="input-title"
          >
          <b-input-group>
            <b-form-input
              id="input-5b"
              v-model="form.password"
              type="password"
              class="forminput"
              required
              @keyup="showpassworderror"
              :state="validpassword"
              placeholder="Create a new password "
            ></b-form-input>
            <b-input-group-append>
            <b-button id="vis-on" class="passwordview" variant="light" @click="showPW"><b-icon-eye font-scale="2"></b-icon-eye></b-button>
            <b-button id="vis-off" class="passwordview" variant="light" @click="showPW"><b-icon-eye-slash font-scale="2"></b-icon-eye-slash></b-button>
            </b-input-group-append>
          </b-input-group>  
            <!-- <div id="pw-view"  title="Show Password"><img src="baseline-visibility-24px.svg" alt="Password Visibility" id="vis-on"><img src="baseline-visibility_off-24px.svg" alt="Password Visibility Off" id="vis-off"></div> -->

            <b-form-invalid-feedback :state="validpassword">
              {{this.passworderror}}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- <br> -->
      <b-row align-h="center">
        <b-col lg="6"> 
          <!-- :disabled="!validpageone"  -->
          <b-button :disabled="!validpageone" @click="gotopage2" variant="light" block squared>Next Page</b-button>
        </b-col>
      </b-row>
    </div> <!-- END PAGE ONE -->

    <div v-show="showpagetwo"> <!-- START PAGE TWO -->
    <br>
      <b-row align-h="center">
        <b-col lg="6"> 
          <b-button @click="gotopage1" variant="light" block squared>Previous Page</b-button>
        </b-col>
      </b-row>
    <br>
      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-6"
            label="الإسم الأول:"
            label-for="input-6"
            class="input-title rtl"
          >
            <b-form-input
              id="input-6"
              v-model="form.firstnameAR"
              dir="RTL"
              type="text"
              class="forminput"
              required
              :state="validarabic(form.firstnameAR)"
              @keyup="removenonarabicfirstname()"
              placeholder="الإسم الأول (باللغة العربية)"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-7"
            label="اللقب:"
            label-for="input-7"
            class="input-title rtl"
          >
            <b-form-input
              id="input-7"
              v-model="form.lastnameAR"
              dir="RTL"
              type="text"
              class="forminput"
              required
              :state="validarabic(form.lastnameAR)"
              @keyup="removenonarabiclastname()"
              placeholder="اللقب (باللغة العربية)"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-11"
            label="Company Name:"
            label-for="input-11"
            class="input-title "
          >
            <b-form-input
              id="input-11"
              v-model="form.company"
              type="text"
              class="forminput"
              placeholder=" Company Name - اسم الشركة "
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-8"
            label="Gender:"
            label-for="input-8"
            class="input-title "
          >
            <v-select v-model="form.gender" :options="['Male','Female']" label="title" class="style-chooser">
              <template #search="{attributes, events}">
              <input
                class="vs__search"
                :required="!form.gender"
                v-bind="attributes"
                v-on="events"
              />
            </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col lg="6">    
          <b-form-group
            id="input-group-9"
            label="Work Field ( مجال العمل او طالب/ة):"
            label-for="input-9"
            class="input-title "
          >
            <v-select v-model="form.workfield" :options="workfields" taggable push-tags class="style-chooser">
              <template #search="{attributes, events}">
              <input
                class="vs__search"
                :required="!form.workfield"
                v-bind="attributes"
                v-on="events"
              />
            </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="center">
          <b-col lg="6">    
            <b-form-group
              id="input-group-10"
              label="Specialty (التخصص):"
              label-for="input-10"
              class="input-title "
            >
              <v-select v-model="form.specialty" :options="specialties" taggable  push-tags class="style-chooser">
                <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!form.specialty"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>


      <b-row align-h="center">
        <b-col lg="6"> 
          <!-- :disabled="!validpagetwo"  -->
          <b-button :disabled="!validpagetwo" @click="gotopage3" variant="light" block squared>Review</b-button>
        </b-col>
      </b-row>
    </div> <!-- END PAGE TWO -->

    <div v-show="showpagethree"> <!-- START PAGE THREE -->
      <b-row align-h="center">
        <b-col lg="6"> 
          <b-button @click="gotopage2" variant="light" block squared>Previous Page</b-button>
        </b-col>
      </b-row>
    <!-- Start PAGE THREE -->
      <br class="smallbr">
      <b-row align-h="center">
        <b-col lg="6">
          <center><h5>Please review your information and take a photo of it</h5></center>
          <b-table-lite table-class="tableclass" :items="[form]" :fields="fields" bordered outlined  striped hover responsive stacked per-page="1" table-variant="light"/>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="6">
          <center><h6>{{this.posterror}}</h6></center>
        </b-col>
      </b-row>
        
      <br class="smallbr">
      <b-row align-h="center">
        <b-col lg="6"> 
          
          <b-button :disabled="submitdiabled" @click="postPost" variant="light" block squared>Submit</b-button>
        </b-col>
      </b-row>

    </div> <!-- END PAGE THREE -->
    <div v-show="showpagefour"> <!-- START PAGE THREE -->
      <br >
      <b-row align-h="center">
        <b-col lg="8">
          <center><h3>Thank you {{this.form.firstname}},</h3></center>
          <br>
          <center><h3>Your Registration Has Been Completed succsfully</h3></center>
        </b-col>
      </b-row>
      <br><br>
      <b-row align-h="center">
        <b-col lg="6"> 
          
          <b-button @click="newregistration" variant="light" block squared>New Registration</b-button>
        </b-col>
      </b-row>
    </div> <!-- END PAGE THREE -->  
    </b-form>  <!-- END FORM -->
    
  <br class="clear"/>
  </b-container>
</template>

<script>
import 'vue-select/dist/vue-select.css';
function getDefaultData() {
  return {
        form: {
          firstname: '',
          middlename: '',
          lastname: '',
          FullEnglishName: '',
          email: '',
          phone: '',
          username: '',
          password: '',
          firstnameAR: '',
          lastnameAR: '',
          FullArabicName: '',
          company: '',
          gender: '',
          workfield: '',
          specialty: '',
        },
        fields: ['FullEnglishName','FullArabicName','email','phone','company','gender','workfield','specialty','username','password'],
        validemail: false,
        validphone: false,
        validusername: false,
        validenglishname: false,
        showmiddlename: false,
        emailerror: '',
        usernameerror: '',
        passworderror: '',
        phone: '', 
        showpageone : true,
        showpagetwo : false,
        showpagethree : false,
        showpagefour : false,
        specialties: [],
        workfields: [],
        submitdiabled : false,
        domain: '',
        // domain: 'https://nuqta.ly',
        postdata: '',
        posterror: '',
      }
  }
export default {
  name: 'Home',
  components: {
    // register
    // ValidationProvider
  },
  data() { return getDefaultData(); },
  
  filters: {
    // capitalize: function (value) {
    //   if (!value) return ''
    //   value = value.toString()
    //   return value.charAt(0).toUpperCase() + value.slice(1)
    // }
  },
  computed: {
      emailvalidation: function () {
         if(this.validemail == true){
           return true;
         }
         else return false;
      },
      usernamevalidation: function () {
         if(this.validusername == true){
           return true;
         }
         else return false;
      },
      validpassword: function () {
         if(this.form.password.length < 7) {return false;}
         else{return true;}
      },
      validfirstnameAR: function () {
         if(this.form.firstnameAR.length < 1) {return false;}
         else{return true;}
      },
      validlastnameAR: function () {
         if(this.form.lastnameAR.length < 1) {return false;}
         else{return true;}
      },
      validgender: function () {
         if(this.form.gender == '') {return false;}
         else{return true;}
      },
      validworkfield: function () {
         if(this.form.workfield == '') {return false;}
         else{return true;}
      },
      validspeciality: function () {
         if(this.form.specialty == '') {return false;}
         else{return true;}
      },
      validpageone: function () {
         if(this.validenglishname && this.validemail && this.validphone && this.validemail && this.validpassword){
           return true;
         }
         else return false;
      },
      validpagetwo: function () {
         if(this.validfirstnameAR && this.validlastnameAR && this.validgender && this.validworkfield && this.validspeciality){
           return true;
         }
         else return false;
      },
  },
  methods: { 
      gotopage1(){
        this.showpageone = true;
        this.showpagetwo = false;
        this.showpagethree = false;
        this.showpagefour = false;
      },
      gotopage2(){
        this.showpageone = false;
        this.showpagetwo = true;
        this.showpagethree = false;
        this.showpagefour = false;
      },
      gotopage3(){
        this.showpageone = false;
        this.showpagetwo = false;
        this.showpagethree = true;
        this.showpagefour = false;
      },
      gotopage4(){
        this.showpageone = false;
        this.showpagetwo = false;
        this.showpagethree = false;
        this.showpagefour = true;
      },
      showpassworderror(){
        this.passworderror = "Password Must Be At Least 7 Charachters Long";
      },
      convertphone(payload){
        var newphone = payload.nationalNumber;
        if (payload.countryCallingCode != '218') newphone = payload.formattedNumber;
        if (payload.countryCallingCode == '218' && newphone.substr(0,1) == '9' && newphone.length == 9){newphone = '0'+newphone;}
        this.validphone = payload.isValid;
        //newphone = newphone.replace(/-/g, "");
        this.form.phone = newphone;
      },
      validarabic: function (input) {
        if (input < 3) return false;
        // eslint-disable-next-line
        var re = /^[\u0621-\u064A ]+$/;
        if (!re.test(input)) return false;
        this.form.FullArabicName = this.form.firstnameAR + ' ' + this.form.lastnameAR;
      },  
      removenonarabicfirstname: function (){
        //Remove Non English Charachters
        var re = /^[\u0621-\u064A ]+$/;
        if (!re.test(this.form.firstnameAR)) this.form.firstnameAR= this.form.firstnameAR.substr(0,this.form.firstnameAR.length-1);
      },
      removenonarabiclastname: function (){
        //Remove Non English Charachters
        var re = /^[\u0621-\u064A ]+$/;
        if (!re.test(this.form.lastnameAR)) this.form.lastnameAR= this.form.lastnameAR.substr(0,this.form.lastnameAR.length-1);
      },
      validenglish: function (input) {
        if (input < 3) return false;
        // eslint-disable-next-line
        var re = /^[A-Za-z]+$/;
        if (!re.test(input)) return false;
        
        return true;
      },
      removenonenglishfirstname: function (){
        //Remove Non English Charachters
        var re = /^[A-Za-z]+$/;
        if (!re.test(this.form.firstname)) this.form.firstname= this.form.firstname.substr(0,this.form.firstname.length-1);
        //Capitalize the First Word
        var value = this.form.firstname.toString();
        this.form.firstname = value.charAt(0).toUpperCase() + value.slice(1);
      },
      removenonenglishmiddlename: function (){
        //Remove Non English Charachters
        var re = /^[A-Za-z]+$/;
        if (!re.test(this.form.middlename)) this.form.middlename= this.form.middlename.substr(0,this.form.middlename.length-1);
        //Capitalize the First Word
        var value = this.form.middlename.toString();
        this.form.middlename = value.charAt(0).toUpperCase() + value.slice(1);
      },
      removenonenglishlastname: function (){
        //Remove Non English Charachters
        var re = /^[A-Za-z]+$/;
        if (!re.test(this.form.lastname)) this.form.lastname= this.form.lastname.substr(0,this.form.lastname.length-1);
        //Capitalize the First Word
        var value = this.form.lastname.toString();
        this.form.lastname = value.charAt(0).toUpperCase() + value.slice(1);
        this.checkfullenglishname();
      },
      checkfullenglishname: function (){
        var space = ' ';
        if(!this.showmiddlename) space = '';
        this.form.FullEnglishName = this.form.firstname + ' ' + this.form.middlename + space + this.form.lastname;
        if(this.form.lastname != ''){
          var api = this.domain + '/register/checkenglishname.php?fullname=' + this.form.FullEnglishName;
          this.axios.get(api).then((response) => {
            
            if(response.data == true) {
              this.validenglishname = false;
              this.showmiddlename = true;
            }
            else {
              // console.log('this email is allowed');
              this.validenglishname =  true;
              this.showmiddlename = false;
            }
          });
        }else {
          this.validenglishname =  false;
        }
        if(this.showmiddlename && this.form.middlename == '')this.validenglishname =  false;
      },
      emailbackendcheck: function () {
        // console.log('checking backend');
        this.validemail = false;
        this.emailerror = 'Email format should be  xxxxx@xxxxx.xxx';
        // eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(this.form.email)) return false;

        //if(this.form.email.length < 6) {return false;}
        var lastThree = this.form.email.substr(this.form.email.length - 3);
        if(lastThree == '.co') {return false;}

        //check recaptcha
        if(!this.recaptcha())return false;

        //Check if the email is already registered in Nuqta's system
        var api = this.domain + '/register/checkemail.php?email=' + this.form.email;
        this.axios.get(api).then((response) => {
          
          if(response.data == true) {
            // console.log('this email already exists in the database');
            this.validemail = false;
            this.emailerror = 'This email is already registered';
          }
          else {
            // console.log('this email is allowed');
            this.validemail =  true;
          }
        })

        //Check if the email is a real email
        fetch("https://email-checker.p.rapidapi.com/verify/v1?email="+ this.form.email, {
          "method": "GET",
          "headers": {
            "x-rapidapi-host": "email-checker.p.rapidapi.com",
            "x-rapidapi-key": "b880734806mshb14f92c04f8c5bdp16d450jsn02f609ea4c36"
          }
        })
        .then(response => {
          return response.json();
        }).then(data => {
          // `data` is the parsed version of the JSON returned from the above endpoint.
          //console.log(data);   { "userId": 1, "id": 1, "title": "...", "body": "..." }
          if(data.status == 'invalid') {
            this.validemail = false;
            this.emailerror = 'This is not a real Email address';
            }else {
              this.form.username = data.user;
              this.usernamebackendcheck();
              }
        });
 
        //console.log(response.data);
        // console.log('returning from backend ' + this.validemail);
        return this.validemail;
      },
      usernamebackendcheck() {
        this.validusername = false;

        //Remove Non English Charachters
        var re = /^[A-Za-z]+$/;
        if (!re.test(this.form.username)) this.form.username= this.form.username.substr(0,this.form.username.length-1);
        
        //ِError on short username
        if(this.form.username.length < 4) {
          this.usernameerror = 'The username must be more than 3 characters long';
          return false;
          }
        
        //Check backend  
        var api = this.domain + '/register/checkusername.php?uid=' + this.form.username;
        this.axios.get(api).then((response) => {
          
          if(response.data == true) {
            // console.log('this email already exists in the database');
            this.validusername = false;
            this.usernameerror = 'This username is already registered';
          }
          else {
            // console.log('this email is allowed');
            this.validusername =  true;
          }
        })
      },
      showPW() {
        var pw = document.getElementById("input-5b");
        //var pwview = document.getElementById("pw-view");
        var on = document.getElementById("vis-on");
        var off = document.getElementById("vis-off");
        if (pw.type === "password") {
          pw.type = "text";
          on.style.display = "none";
          off.style.display = "block";
          //pwview.title = "Hide Password";
        } else {
          pw.type = "password";
          off.style.display = "none";
          on.style.display = "block";
          //pwview.title = "Show Password";
        }
      },
      async recaptcha() {
        
        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded();
        const recaptcha = this.$recaptchaInstance;
        
        // Hide reCAPTCHA badge:
        recaptcha.hideBadge();
        
        // Execute reCAPTCHA with action "login".
        const token = await this.$recaptcha('login')
        //console.log(token);
        // Do stuff with the received token.
        var api = this.domain + '/register/recaptcha-v3.php?token=' + token;
        this.axios.get(api).then((response) => {
          if(response.data == false) {
            //console.log('The recaptcha failed');
            this.validemail = false;
            this.emailerror = 'The recaptcha failed';
            return false;
          }else{
            //console.log('recaptcha success');
            return true;
          }
        })//.catch(err => console.log(err))
      },
      postPost() {
        this.submitdiabled = true;
        /*
        this.axios.post(this.domain + '/register/vuecreate.php', {
          body: this.form
        })
        .then(response => {
          response.json();
        })
        .catch(data => {
          //this.errors.push(e)
          //console.log(data);
          this.postdata = data;
        })
        */
       this.axios({
        method: 'post',
        // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        url: this.domain + '/register/vuecreate.php',
        data: this.form
        })
        .then(response => {
          // console.log(response.data);
          this.postdata = response.data;
            //On Success
            // if(this.postdata == "postsuccess"){
            if(this.postdata.includes("postsuccess")){
              this.gotopage4();
            }else{
              this.posterror = this.postdata;
              this.submitdiabled = false;
            }
        })

      },
      newregistration(){
        //Restore Form Data
        var def = getDefaultData();
        Object.assign(this.$data, def);
      }
  },
  created() {
    //Get specialties
    var api1 = this.domain + '/register/databasequery.php?field=Speciality';
    this.axios.get(api1).then((response) => {
      //console.log(response);
      this.specialties = response.data;
    })  
    //Get workfields
    var api2 = this.domain + '/register/databasequery.php?field=WorkField';
    this.axios.get(api2).then((response) => {
      //console.log(response);
      this.workfields = response.data;
    })  

  }    
}
</script>
<style>
.tableclass { text-align: center; }
.tableclass td {
  padding: 10px;
}
.smallbr{
  display: block; /* makes it have a width */
  content: ""; /* clears default height */
  margin-top: 10px; /* change this to whatever height you want it */
}
  .logoimg{
    width: 50%;
    max-width: 10cm;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0.5cm;
    padding-top: 0.5cm;
  }

input, b-form-input, .forminput{
  font-family: "coheadline";
  height: 1cm;
  font-size: 0.5cm;
  border-radius: 0.15cm;
  padding: 0.3cm 0.5cm;
}  
input[type=text]:focus, input[type=email]:focus,input[type=number]:focus,input[type=password]:focus, select:focus {
  /* border: 0.5mm solid #4d90fe; */
  background-color: #e6e6e6;
}
input:required:invalid {
  border: 2px solid red;
}
input:required:valid { 
  border: 2px solid green; 
}
.rtl{
  text-align: right;
  direction: RTL;
}

.style-chooser .vs__search::placeholder,
  .style-chooser .vs__dropdown-toggle,
  .style-chooser .vs__dropdown-menu {
    background: #ffffff;
    border: none;
    color: #ffffff;
    text-transform: lowercase;
    font-variant: small-caps;
  }
.style-chooser .vs__clear,
  .style-chooser .vs__open-indicator {
    fill: #394066;
  }
.passwordview{
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 19px;
  padding-left: 19px;
}
#pw, #pw-view {
  vertical-align: bottom;
}
#pw {
  display: inline-block;
  width: 85%;
  border-radius: 0.15cm 0 0 0.15cm;
}
#pw-view {
  display: inline-block;
  height: 1.485cm;
  width: 15%;
  border-radius: 0 0.15cm 0.15cm 0;
  background-color: #fff;
  border: none;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}
#pw-view img {
  height: 80%;
  margin: 10% auto 0 auto;
  display: block;
}
#vis-off {
  display: none;
}

.container{
  min-height: 100%;
}
.clear { clear: both; }
</style>